import CardEstatistica from '../../componentes/CardEstatistica';
import { MonthlyRevenueChart, PerformanceChart } from '../../componentes/GraficosDashboard';
import { IconCheck, IconDashboard, IconWhatsApp } from '../../componentes/Icons';
import './DashboardPrincipal.css';

const DASHBOARD_ICONS = {
    revenue: <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>,
    appointments: <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
    ticket: <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>,
    occupancy: <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.21 15.89A10 10 0 1 1 8 2.83" /><path d="M22 12A10 10 0 0 0 12 2v10z" /></svg>,
    profit: <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>,
    edit: <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
    users: <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
};

const SecaoDashboard = ({
    periodRevenue,
    timeFilter,
    formatCurrency,
    periodAppointments,
    completedCount,
    periodAverageTicket,
    occupancyRate,
    periodNetProfit,
    monthlyData,
    barberPerformance,
    goalProgress,
    currentMonthRevenue,
    revenueGoal,
    isEditingGoal,
    setIsEditingGoal,
    handleSaveUnitConfig,
    setRevenueGoal,
    generateMonthlyReport,
    pendingReminders = [],
    handleRemind,
    markAsReminded,
    totalClients
}) => {
    // Calcular larguras para as barras de performance
    const maxBarberRevenue = Math.max(...barberPerformance.map(b => b.total || 0), 1);
    const chartBarberData = barberPerformance.map(b => ({
        ...b,
        width: Math.min((b.total / maxBarberRevenue) * 100, 100)
    }));

    return (
        <div className="section-dashboard fade-in">
            <div className="section-header-row">
                <h2 className="section-main-title">Métricas de Desempenho</h2>
                <button className="report-btn-dashboard" onClick={generateMonthlyReport} title="Gerar PDF de Fechamento">
                    <IconDashboard />
                    <span>Relatório de Fechamento (PDF)</span>
                </button>
            </div>

            <div className="stats-container">
                <CardEstatistica title="Faturamento" value={formatCurrency(periodRevenue)} hint={timeFilter === 'Total' ? 'Histórico total' : `Período: ${timeFilter}`} icon={DASHBOARD_ICONS.revenue} color="#D4AF37" />
                <CardEstatistica title="Agendamentos" value={periodAppointments.length} hint={`${completedCount} finalizados`} icon={DASHBOARD_ICONS.appointments} color="#B19CD9" />
                <CardEstatistica title="Ticket Médio" value={formatCurrency(periodAverageTicket)} hint="Por atendimento" icon={DASHBOARD_ICONS.ticket} color="#4da6ff" />
                <CardEstatistica title="Total de Clientes" value={totalClients} hint="Clientes únicos" icon={DASHBOARD_ICONS.users} color="#ff8533" />
                <CardEstatistica title="Ocupação" value={`${occupancyRate}%`} hint="Capacidade produtiva" icon={DASHBOARD_ICONS.occupancy} color="#4dff88" />
                <CardEstatistica title="Lucro Líquido" value={formatCurrency(periodNetProfit)} hint="Ganhos - Despesas" icon={DASHBOARD_ICONS.profit} color="#4dff88" />
            </div>

            <div className="analytics-grid">
                <MonthlyRevenueChart data={monthlyData} formatCurrency={formatCurrency} />
                <PerformanceChart data={chartBarberData} formatCurrency={formatCurrency} />

                <div className="metrics-card goal-card">
                    <div className="goal-header">
                        <h3>Meta de Faturamento (Mês)</h3>
                        <div className="goal-status-tag">{goalProgress}%</div>
                    </div>
                    <div className="goal-content">
                        <div className="goal-numbers">
                            <div className="goal-stat">
                                <span className="goal-label">Alcançado</span>
                                <span className="goal-value">{formatCurrency(currentMonthRevenue)}</span>
                            </div>
                            <div className="goal-stat right">
                                <span className="goal-label">Sua Meta</span>
                                {isEditingGoal ? (
                                    <input type="number" value={revenueGoal} onChange={(e) => setRevenueGoal(e.target.value)} onBlur={() => { handleSaveUnitConfig(); setIsEditingGoal(false); }} onKeyDown={(e) => e.key === 'Enter' && (e.target.blur())} autoFocus className="goal-input-minimal" />
                                ) : (
                                    <div className="goal-value-display" onClick={() => setIsEditingGoal(true)}>
                                        <span className="goal-value">{formatCurrency(Number(revenueGoal))}</span>
                                        <button className="goal-edit-btn">{DASHBOARD_ICONS.edit}</button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="goal-progress-container">
                            <div className="goal-progress-bar" style={{ width: `${goalProgress}%`, backgroundColor: Number(goalProgress) >= 100 ? '#4dff88' : '#D4AF37' }}>
                                <div className="goal-progress-glow"></div>
                            </div>
                        </div>
                        <p className="goal-hint">
                            {Number(goalProgress) >= 100 ? "🎉 Parabéns! Meta batida com sucesso." : `Faltam ${formatCurrency(Math.max(Number(revenueGoal) - currentMonthRevenue, 0))} para concluir.`}
                        </p>
                    </div>
                </div>

                <div className="metrics-card reminders-card">
                    <div className="card-header-with-icon">
                        <IconWhatsApp size={20} color="#25D366" />
                        <h3>Lembretes Pendentes (Amanhã)</h3>
                        <span className="badge-count">{pendingReminders.length}</span>
                    </div>
                    <div className="reminders-list">
                        {pendingReminders.length > 0 ? (
                            pendingReminders.slice(0, 5).map(app => (
                                <div key={app.id} className="reminder-item-dashboard">
                                    <div className="reminder-info">
                                        <span className="client-name">{app.client}</span>
                                        <span className="app-time">{app.time} - {app.service}</span>
                                    </div>
                                    <div className="reminder-actions-minimal">
                                        <button className="reminder-btn zap" onClick={() => handleRemind(app)} title="Enviar WhatsApp">
                                            <IconWhatsApp size={14} />
                                        </button>
                                        <button className="reminder-btn done" onClick={() => markAsReminded(app.id)} title="Marcar como enviado">
                                            <IconCheck size={14} />
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="empty-reminders">Tudo em dia! Nenhum lembrete para amanhã.</p>
                        )}
                        {pendingReminders.length > 5 && (
                            <p className="view-all-hint">Ver mais na aba Agenda</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecaoDashboard;
